import * as yup from 'yup';
import { compare3DigitsFloats } from 'utils/number';

export const expeditionFormSchema = (pt: any): yup.AnyObjectSchema =>
  yup.object().shape({
    expeditionClientPortions: yup
      .array()
      .test('atLeastOneValidated', pt('validation.expeditionClientPortions.atLeastOneChecked'), (value, context) => {
        return !!value && value.some(({ checked }) => checked);
      })
      .test('weightSumValidation', pt('validation.weight.sumsDontAddUp'), (value, context) => {
        const sumOfWeight =
          value?.reduce((total, { weight }) => {
            const weightInThousandths = Math.round((parseFloat(weight || '0') ?? 0) * 1000);
            return total + weightInThousandths; // Ajouter en tant qu'entier
          }, 0) / 1000;
        return !!value && compare3DigitsFloats(context.parent.weight ?? 0, sumOfWeight);
      })
      .test('percentageSumValidation', pt('validation.weight.sumsDontAddUp'), (value, context) => {
        const sumOfPercentage = value?.reduce(
          (total, { percentage }): number => total + (parseFloat(percentage || '0') ?? 0),
          0,
        );
        return !!value && compare3DigitsFloats(100, sumOfPercentage);
      })
      .of(
        yup.object().shape({
          weight: yup
            .mixed()
            .nullable()
            .when('checked', {
              is: true,
              then: yup
                .number()
                .required(pt('validation.expeditionClientPortions.requiredWeight'))
                .typeError(pt('validation.expeditionClientPortions.requiredWeight')),
            }),
        }),
      ),
  });
